import { io, Socket } from 'socket.io-client'

export default defineNuxtPlugin((nuxtApp) => {
    const getWssUrl = () => {
        const hostname = window.location.hostname
        
        if (hostname === 'yourservice.ae') {
            return 'wss://backend-prod-bhlfzy4vpq-ez.a.run.app'
        } else if (hostname === 'test.yourservice.bh') {
            return 'wss://backend-pre-prod-bhlfzy4vpq-ez.a.run.app'
        } else {
            return 'wss://backend-dev-bhlfzy4vpq-ez.a.run.app'
        }
    }

    const socket: Socket = io(getWssUrl(), {
        autoConnect: false,
        transports: ['websocket']
    })

    return {
        provide: {
            ioSocket: socket
        }
    }
})

